<template>


  <v-card-text class="mt-0 pt-0" >
    <v-data-table
      :mobile-breakpoint="NaN"
      must-sort
      :headers="headers"
      :items="searchTypes"
      hide-default-footer
      no-data-text="no searching information available - try reset below"
    >
      <template v-slot:item.iconType="{ item }">
        <v-icon :color="getTypeIconColor(item.iconType)">
          {{ getTypeIcon(item.iconType) }} 
        </v-icon>
        <span  class="pl-1 subtitle-1">{{uncamel(item.iconType)}}</span>
      </template>

      <template v-slot:item.active="{ item }">

        <v-checkbox 
          hide-details 
          v-model="item.active" @change="itemChanged(item)"
        ></v-checkbox>

      </template>
    </v-data-table>
  </v-card-text>

</template>
<script>
import { SearchUtils } from '@/js'
import { SearchVariableFilters } from '@/gql'
import { findSearchFilter, getIcon, getIconColor } from '@/js/store'
import { searchVariableFilterMutate } from '@/js/apollo'
export default {
  props: {
    itemType: {
      type: String,
      required: true
    }
  }, 
  data: () => ({
    SearchVariableFilters: null,
    headers: [{
      value:'iconType',
      text: 'Search type',
      width:'50%',
      sortable: false,
      align: 'start'
    }, {
      value:'active',
      text: 'Include',
      sortable: false,
      align: 'start'
    }]
  }),
  methods: {
    getTypeIcon (type) {
      return getIcon(type)
    },
    getTypeIconColor (type) {
      return getIconColor(type)
    },
    itemChanged(item) {
      // so now we need to update the active filters
      const fs = this.searchVariableFilter
      // and change the status
      const { active, iconType } = item
      const pos = fs.value.value.indexOf(iconType)
      // firstly get rid of it
      if(pos !== -1) fs.value.value.splice(pos, 1)
      // then push it if we need it
      if (active) {
        fs.value.value.push(iconType)
      }
      // now mutate that
      searchVariableFilterMutate(this.SearchVariableFilters)
    },
    uncamel (text) {
      return SearchUtils.unCamel({ pluralize: true, text })
    }
  },
  computed: {
    targetType () {
      return this.itemType
    },
    searchVariableFilter () {
      // these are the reasons that are currently enabled by the user for this type of search
      return this.SearchVariableFilters
        ? this.SearchVariableFilters.SearchFilters.find(f => f.itemType === this.targetType)
        : null
    },
    searchTypes () {
      // these will be all the types that could be enabled for this type of search
      // marked active or not depending on whether the user has disabled them
      if (!this.targetType || !this.searchVariableFilter) return null
      // now we need to filter those that are disabled
      const fs = findSearchFilter({ itemType: this.targetType })
      // shouldnt happen but for debugging purposes
      if (!fs) {
        console.log('missing settings searchfilter for ', this.targetType)
      }

      return fs.value.value.map(f => ({
        active: this.searchVariableFilter.value.value.indexOf(f) !== -1,
        iconType: f
      }))
    }
  },
  apollo: {
    SearchVariableFilters: {
      query: SearchVariableFilters
    }
  }
}
</script>
